export const EVENTS = {
  WALLET: {
    REFRESH: 'wallet.refresh',
    REFRESHING: 'wallet.refreshing',
    REFRESH_ERROR: 'wallet.error',
    REFRESHED: 'wallet.refreshed'
  },
  WITHDRAW: {
    REQUEST: 'wallet.withdraw.request',
    PROCESSING: 'wallet.withdraw.processing',
    SUCCESS: 'wallet.withdraw.success',
    ERROR: 'wallet.withdraw.error'
  }
};
export const ENDPOINTS = {
  WALLET: {
    GET: '/wallet/balance/{userId}?service={lacasaeBettingServiceName}-customer&country=BJ&processor={lacasaeBettingServiceName}-customer&currency=XOF&group={lacasaeBettingServiceName}',
    WITHDRAW: '/api/users/{userId}/withdrawals'
  }
};
